import { useNavigate, useLocation } from "react-router-dom";
import { IconAssistant } from "./MinimalIcons";

// Páginas onde o botão NÃO deve aparecer
const EXCLUDED_PAGES = ["/", "/login", "/register", "/assistant"];

export default function FloatingAssistant() {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Não mostrar nas páginas excluídas
  if (EXCLUDED_PAGES.some(page => location.pathname === page)) {
    return null;
  }

  return (
    <button
      onClick={() => navigate("/assistant")}
      className="fixed bottom-20 right-5 w-14 h-14 bg-neutral-900 rounded-full flex items-center justify-center shadow-lg hover:bg-neutral-800 active:scale-95 transition-all z-50"
      data-testid="floating-assistant-global"
      aria-label="Assistente eZelo."
    >
      <IconAssistant className="w-6 h-6 text-white" />
    </button>
  );
}
